// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2DIHw","container":"styles_container__19fup","title":"styles_title__3OqZa","wrapper":"styles_wrapper__AcPFy","answer":"styles_answer__2X75D"};